export const PETBREED = 'petBreed';

/**
 * Actions to be connected from redux userData.
 * @type {Object}
 */
export const actionsToConnect = {};

/**
 * Values to be connected from redux userData.
 * @param  {object} state   Redux state
 * @type {Array}
 */
export const propsToConnect = state => {
  const { section: { packageData: { initialValues: { petBreed } } } } = state;
  return { petBreed };
};

/**
 * Sets a suggestion in the form.
 * @param  {Object}   suggestion Object representing a suggestion.
 * @param  {Function} setValues  Set value function of the Formik component.
 * @param  {Array}    values     The current Formik values.
 */
const setFormValues = (suggestion, setValues, values) => {
  const payload = {
    ...values,
    petBreed: suggestion,
  };
  setValues(payload);
};

/**
 * Clears the form.
 * @param  {Function} setValues  Set value function of the Formik component.
 * @param  {Array}    values     The current Formik values.
 */
const clearFormValues = (setValues, values) => {
  const payload = {
    ...values,
    petBreed: null,
  };
  setValues(payload);
};

/**
 * Sets the value of the field.
 * @param  {Object} suggestion Object representing a suggestion.
 * @param  {Object} that       This object from caller.
 */
export const setValue = (suggestion, that) => {
  if (!that.state.isTyping) {
    that.setState({
      value: suggestion,
    });
  }
};

/**
 * Function that fetches the value to render.
 * @param  {Object} values The current Formik values.
 * @param  {Object} that   This object from caller.
 * @return {string}        The value to show.
 */
export const getValue = (values, that) => {
  return that.state.value;
};

/**
 * How a suggestion looks when selected.
 * @param  {Object}   suggestion Object representing a suggestion.
 * @param  {Function} setValues  Set value function of the Formik component.
 * @param  {Array}    values     The current Formik values.
 * @return {string}              String representation of the suggestion.
 */
export const getSuggestionValue = (suggestion, setValues, values) => {
  setFormValues(suggestion, setValues, values);
  return suggestion;
};

/**
 * How should the suggestions be rendered in the list.
 * @param  {Object} suggestion Object representing a suggestion.
 * @return {string}            String representation of the suggestion.
 */
export const renderSuggestion = suggestion => (
  suggestion
);

/**
 * Event to be called on change.
 * @param  {InputEvent} event     The event.
 * @param  {string}     newValue  The current value of the input field.
 * @param  {Object}     that      The "this" object of the caller.
 */
export const onChangeEvent = (event, newValue, that) => {
  that.setState({
    isTyping: true,
    value: newValue,
  });
};

/**
 * Event to call onBlur.
 * @param  {Object}   that      The "this" object of the caller.
 * @param  {Object}   suggestion The suggestion.
 * @param  {Function} setValues  The set values function of the Formik component.
 * @param  {Object}   values     The current values of the Formik componenet.
 */
export const onBlurEvent = (that, suggestion, setValues, values) => {
  if (!suggestion) {
    return;
  }
  setFormValues(suggestion, setValues, values);
  setValue(suggestion, that);
};

/**
 * onSuggestionsFetchRequested is called whenever new suggestions should be fetched.
 * @param  {string}   value      The value entered into the input field.
 * @param  {Object}   that       The "this" object of the caller.
 * @param  {function} dispatch   The dispatch function of the store.
 * @param  {Function} setValues  Set values function of the Formik component.
 * @param  {Array}    values     The current Formik values.
 */
export const onSuggestionsFetchRequested = (value, that, dispatch, setValues, values) => {
  const { petBreed } = that.props.autoProps;
  if (value.length === 0) {
    that.setState({
      suggestions: [],
    });

    return;
  }

  that.setState({
    isLoading: true,
  });
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;
  const suggestions = petBreed.filter(item =>
    item.toLowerCase().slice(0, inputLength) === inputValue
  );

  if (suggestions.length === 1) {
    const suggestion = suggestions[0];
    setFormValues(suggestion, setValues, values);
    setValue(suggestion, that);
  } else if (suggestions.length === 0) {
    clearFormValues(setValues, values);
  }

  that.setState({
    suggestions,
    isLoading: false,
  });
};

/**
 * onSuggestionsClearRequested is called whenever the suggestions should be cleared.
 * @param  {Object} that  The "this" object of the caller.
 * @param  {Function} setValues  Set values function of the Formik component.
 * @param  {Array}    values     The current Formik values.
 */
export const onSuggestionsClearRequested = (that, setValues, values) => {
  if (that.state.value.length === 0) {
    clearFormValues(setValues, values);
  }
  that.setState({
    suggestions: [],
  });
};

export const shouldRenderSuggestions = () => {
  return true;
};

export const type = PETBREED;
